
export enum InputFieldErrorMessages {
  duplicatedPlayerName = "既に利用されている名前です"
}
